


import React from "react";

export const ErrorIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-5 h-5 text-error-60",
    ...props
}) => {
    return (

        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className={className}  {...props}>
            <g clipPath="url(#clip0_24065_4965)">
                <path d="M10 9C10.5523 9 11 9.44772 11 10L11 14C11 14.5523 10.5523 15 10 15C9.44771 15 9 14.5523 9 14L9 10C9 9.44771 9.44771 9 10 9Z" fill="currentColor" />
                <path d="M10 7.5C10.6904 7.5 11.25 6.94036 11.25 6.25C11.25 5.55964 10.6904 5 10 5C9.30964 5 8.75 5.55964 8.75 6.25C8.75 6.94036 9.30964 7.5 10 7.5Z" fill="currentColor" />
                <path fillRule="evenodd" clipRule="evenodd" d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2Z" fill="currentColor" />
            </g>
            <defs>
                <clipPath id="clip0_24065_4965">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>

    );
};


